define('controllers/mysetting/iframe-help-team.ctrl',['app'], function (app) {
    app.controller('IframeHelpTeam', ['$scope', '$sce', '$state', '$stateParams', 'projectManageService',
        function ($scope, $sce, $state, $stateParams, projectManageService) {
            AUI.HDGWCall.checkLogin(function () {
                var projectKey = $stateParams.projectKey;
                var apiID = $stateParams.apiID;
                var isUpdate = $stateParams.isUpdate
                var startDate = $stateParams.startDate
                var endDate = $stateParams.endDate
                var signParty = $stateParams.signParty


                //满足 apiconsole 的代码定制
                if (projectKey || projectKey == 0) {
                    if (projectKey != 0) {//angular11里面给的"0"
                        projectManageService.setProjectKey(projectKey);
                    }
                    if (apiID) {//说明是给apiDetail使用的
                        $scope.iframeHelpUrl = $sce.trustAsResourceUrl(sysParamCfg.IframeHelpTeamUrl[$state.current.name] + "/" + projectManageService.getProjectKey() + "/detail/" + apiID);
                        return;
                    }
                    if ($state.current.name == 'myApiScope') {
                        $scope.iframeHelpUrl = $sce.trustAsResourceUrl(sysParamCfg.IframeHelpTeamUrl[$state.current.name] + "/" + projectManageService.getProjectKey() + "/myScope");
                        return;
                    }
                    if (projectManageService.getProjectKey() != 0 && projectKey == 0 && ($state.current.name == 'myApi' || $state.current.name == 'apiList' || $state.current.name == 'credentials')) {//给API菜单定制一下
                        $state.go($state.current.name, {projectKey: projectManageService.getProjectKey()}, {reload: true});
                    } else {
                        $scope.iframeHelpUrl = $sce.trustAsResourceUrl(sysParamCfg.IframeHelpTeamUrl[$state.current.name] + "/" + projectManageService.getProjectKey());
                    }
                } else if (signParty == 0 || signParty) {
                    $scope.iframeHelpUrl = $sce.trustAsResourceUrl(sysParamCfg.IframeHelpTeamUrl[$state.current.name] + '/' + signParty);
                } else {
                    //如果是myProject的需要将缓存里面的赋值为0
                    if ($state.current.name == 'myProject') {
                        projectManageService.setProjectKey('0');
                    }
                    if (isUpdate == 1 || isUpdate == 0) {
                        $scope.iframeHelpUrl = $sce.trustAsResourceUrl(sysParamCfg.IframeHelpTeamUrl[$state.current.name] + "/" + isUpdate);
                    } else {
                        if ($state.current.name == 'MyAccount.bills.settlement' || $state.current.name == 'MyAccount.newEarnings' || $state.current.name == 'MyAccount.bills' || $state.current.name == 'MyAccount.newEarnings.settlement') {
                            $scope.iframeHelpUrl = $sce.trustAsResourceUrl(sysParamCfg.IframeHelpTeamUrl[$state.current.name] + '/' + 'settlement');
                        } else if ($state.current.name == 'myReport.payment' && startDate && endDate) {
                            $scope.iframeHelpUrl = $sce.trustAsResourceUrl(sysParamCfg.IframeHelpTeamUrl[$state.current.name] + '?startDate=' + startDate + '&endDate=' + endDate);
                        } else {
                            //打开问题列表页
                            $scope.iframeHelpUrl = $sce.trustAsResourceUrl(sysParamCfg.IframeHelpTeamUrl[$state.current.name]);
                        }

                    }

                }

            });
        }]);
});

